import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/components/organism/Filter/types';

export const textFilters: (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = [
  {
    key: 'test1',
    label: 'test1',
  },
  {
    key: 'test2',
    label: 'test2',
    options: [
      { label: '전체', value: '' },
      { label: 'test1', value: '1' },
      { label: 'test2', value: '2' },
      { label: 'test3', value: '3' },
      { label: 'test4', value: '4' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'test3',
    label: 'test3',
    type: 'DATE_RANGE',
    rangeKeys: [],
  },
  {
    key: 'test4',
    label: 'test4',
  },
  {
    key: 'test5',
    label: 'test5',
  },
  {
    key: 'test6',
    label: 'test6',
  },
];
